/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from './utils/connect';
import keymap from './keymap';
import {ShortcutManager, Shortcuts} from 'react-shortcuts';
import ComponentInfoDialog from './components/info/ComponentInfoDialog';
import { setShowingComponentInfo, getApiComponentInfo } from './api/info/actions';
import AppRedux from './AppRedux';

const SHORTCUT_MANAGER = new ShortcutManager(keymap);

class KeymapApp extends Component {
  state = {
    showDebugOutline: false
  };

  componentWillMount() {
    this.props.fetchApiComponentInfo();
  }

  render() {

    let classes = [
      this.props.className,
      'operatorconsole-wrapper',
      (this.state.showDebugOutline ? 'debug-outline' : '')
    ].join(' ');

    return (
        <div className={classes}>
          <Shortcuts tabIndex = {0} name="OPERATORCONSOLE"
              className="operatorconsole-wrapper__shortcuts-wrapper"
              isolate={true}
              handler={this.handleShortcuts}>
            <AppRedux />
            <ComponentInfoDialog
                isVisible={this.props.isShowingComponentInfo}
                apiInfo={this.props.apiInfo}
                handleClose={this.props.setShowingComponentInfo}
            />
          </Shortcuts>
        </div>
    );
  }

  getChildContext() {
    return {
      shortcuts:SHORTCUT_MANAGER,
    };
  }

  handleShortcuts = (action, event) => {
    switch (action) {
      case 'COMPONENTINFO_OPEN':
        this.props.setShowingComponentInfo(true);
        break;

      case 'TOGGLE_DEBUG_OUTLINE':
        this.setState({showDebugOutline: !this.state.showDebugOutline});
        break;

      default:
        break;
    }
  }

}

KeymapApp.childContextTypes = {
  shortcuts:PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isShowingComponentInfo: state.info.isShowingComponentInfo,
    apiInfo: state.info.apiInfo,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setShowingComponentInfo: (isVisible) => dispatch(setShowingComponentInfo(isVisible)),
    fetchApiComponentInfo: () => dispatch(getApiComponentInfo()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(KeymapApp);
